const NON_RENDERABLE_AVATAR_URLS = new Set(['unimplemented']);

export function resolveRenderableAvatarUrl(
  avatarUrl?: string | null,
): string | null {
  const normalizedAvatarUrl = avatarUrl?.trim() ?? '';

  if (normalizedAvatarUrl.length === 0) {
    return null;
  }

  if (NON_RENDERABLE_AVATAR_URLS.has(normalizedAvatarUrl.toLowerCase())) {
    return null;
  }

  return normalizedAvatarUrl;
}

export function hasRenderableAvatarUrl(avatarUrl?: string | null): boolean {
  return resolveRenderableAvatarUrl(avatarUrl) !== null;
}
